<ion-header>
  <app-header-small title="Checkout now" [isScrollStartPosition]="isScrollStartPosition"></app-header-small>
</ion-header>

<app-closed-tab-modal
  *ngIf="isShowModal"
  (close)="closeModal()"
></app-closed-tab-modal>

<ion-content [scrollEvents]="true" (ionScroll)="updateHeaderLogo($event)">
  <div class="container">
    <div class="container__content">
      <div class="field">
        <div class="field__title">Order summary
          <svg class="field__title-icon field__title-icon--large" xmlns="http://www.w3.org/2000/svg">
            <use xlink:href="./assets/images/icons-sprite.svg#icon-cart"></use>
          </svg>
        </div>
        <div class="field__content">
          <div class="order-tab__container">
            <app-tab-order-status *ngFor="let orderStatus of tabOrdersStatus" [tabOrdersStatus]="orderStatus"></app-tab-order-status>
          </div>
          <div class="divider"></div>
          <div class="price">
            <div class="price__block">
              <span class="price__label">Subtotal</span>
              <span class="price__amount">{{currencySign}}{{ getFormattedPrice(totalPrice) }}</span>
            </div>

            <div class="price__block">
              <span class="price__label">Taxes and fees</span>
              <span class="price__amount">{{currencySign}}{{ getFormattedPrice(totalTaxesPrice) }}</span>
            </div>

            <div *ngIf="totalDiscountsPrice > 0" class="price__block">
              <span class="price__label">Discounts</span>
              <span class="price__amount">- {{currencySign}}{{ getFormattedPrice(totalDiscountsPrice) }}</span>
            </div>

            <div class="divider"></div>
            <div class="price__block">
              <span class="price__label">
                Tip amount
              </span>
              <span class="price__amount">{{currencySign}}{{ getFormattedPrice(cartStore.getTip(tip.restaurant)) }}</span>
            </div>
            <app-tipping [useAutoGratuityPercent]="true" [hidden]="false" [items]="tipAmounts" [closeTabPrice]="totalPrice"
                         [forceTouched]="forceTouched"  [tipType]="tip.restaurant" (validChange)="tippingInvalid = !$event"></app-tipping>

            <div class="divider"></div>
            <div class="price__block">
              <span class="price__label price__label--total">Total</span>
              <span class="price__amount price__amount--total">
                {{currencySign}}{{ getFormattedPrice(total + cartStore.tips)}}
              </span>
            </div>
          </div>
        </div>
        <ion-button class="checkout-btns__btn" color="brand" expand="block" (click)="checkTabAndClose()" [disabled]="isLoading">Close tab</ion-button>
        <p class="checkout-btns__error" *ngIf="showErrorMessage"> We’ve encountered a problem, please try your
          order again. Our engineers have been notified. </p>
      </div>
    </div>
  </div>
  <div class="spinner-wrapper" *ngIf="isLoading">
    <app-spinner></app-spinner>
  </div>
</ion-content>
